import { faCircleDownRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Stack, Typography } from '@mui/material';
import { MprcIconButton } from 'components';
import { DevPlanUsersListViewMode } from 'generated/CoreApi_v1';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DevPlanListFilter, DevPlansBaseList } from 'views/lms/devPlan/Home/List/DevPlansBaseList';

////////////////////////////////////////////////////////////////////////////

export const TeamDevPlans: React.FC = () => {

    const { t } = useTranslation("lms");

    const [viewMode, setViewMode] = useState<DevPlanUsersListViewMode>(DevPlanUsersListViewMode.DirectSubordinates);

    const [filter, setFilter] = useState<DevPlanListFilter>({
        searchText: "",
        advFilters: [],
        pageNumber: 1,
        order: null
    });

    ///
    const handleChangeFilter = (pFilter: Partial<DevPlanListFilter>) => {
        setFilter(state => ({ ...state, ...pFilter }));
    };

    ///
    const handleSwitchAllSubordinates = () => {
        setViewMode(viewMode == DevPlanUsersListViewMode.AllSubordinates ? DevPlanUsersListViewMode.DirectSubordinates : DevPlanUsersListViewMode.AllSubordinates);
    };

    return (
        <DevPlansBaseList
            headerTitle={
                <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="h3">{t("DevPlan.List.TeamViewTitle")}</Typography>
                    <MprcIconButton
                        color={viewMode == DevPlanUsersListViewMode.AllSubordinates ? "warning" : "muted"}
                        title={t("DevPlan.List.Users.AllSubordinatesButtonTooltip")}
                        onClick={handleSwitchAllSubordinates}
                    >
                        <FontAwesomeIcon icon={faCircleDownRight} />
                    </MprcIconButton>
                </Stack>
            }
            filter={filter}
            onChangeFilter={handleChangeFilter}
            viewMode={viewMode}
        />
    );
};
